import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { VENUE_META, STATUS_META, shortHash, logoUrl } from "@/lib/meta";
import { Rocket } from "lucide-react";

export default function Launches() {
  const navigate = useNavigate();
  const [launches, setLaunches] = useState([]);
  useEffect(() => {
    api.get("/launches").then(({ data }) => setLaunches(data)).catch(() => {});
  }, []);

  return (
    <div className="mx-auto max-w-5xl px-5 py-8 lg:px-8">
      <div className="mb-6 flex items-center justify-between">
        <div><h1 className="text-2xl font-bold tracking-tight">Launches</h1><p className="text-sm text-dust">Every launch you've run.</p></div>
        <Button onClick={() => navigate("/app/launch")} className="gap-2 bg-juice text-ink hover:bg-juice/90 font-semibold" data-testid="launches-new"><Rocket size={16} /> New launch</Button>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {launches.map((l) => {
          const v = VENUE_META[l.venue] || {};
          const st = STATUS_META[l.status] || STATUS_META.draft;
          const pct = l.budget_total ? Math.round((l.budget_spent / l.budget_total) * 100) : 0;
          return (
            <Link key={l.id} to={`/app/launches/${l.id}`} className="rounded-2xl border border-line bg-surface p-5 transition-colors hover:border-juice/40" data-testid={`launch-card-${l.ticker}`}>
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  {logoUrl(l.logo) && <img src={logoUrl(l.logo)} alt="" className="h-9 w-9 rounded-lg border border-line object-cover" />}
                  <div><span className="font-mono text-lg text-cream">${l.ticker}</span><p className="text-sm text-dust">{l.name}</p></div>
                </div>
                <span className={`rounded-full border px-2.5 py-0.5 text-xs ${st.cls}`}>{st.label}</span>
              </div>
              <div className="mt-4 flex items-center gap-2 text-xs">
                <span className="rounded-md bg-raised px-2 py-1" style={{ color: v.color }}>{v.name}</span>
                <span className="font-mono text-dust">{v.chain}</span>
              </div>
              {l.contract_address && <p className="mt-3 font-mono text-[11px] text-dust">{shortHash(l.contract_address)}</p>}
              <div className="mt-3">
                <div className="mb-1 flex justify-between font-mono text-[11px] text-dust"><span>Budget</span><span>${l.budget_spent}/${l.budget_total}</span></div>
                <div className="h-1.5 overflow-hidden rounded-full bg-raised"><div className="h-full bg-juice" style={{ width: `${pct}%` }} /></div>
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
